import ar from "./ar";
import en from "./en";

const resources = {
  ar: ar,
  en: en,
};

export type Resources = {
  ar: typeof ar;
  en: typeof en;
};

export default resources;
